import * as React from "react";
import { SVGProps } from "react";

const Cloudcoin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 212 206"
    {...props}
  >
    <style>{".st0{fill:#338fff}"}</style>
    <switch>
      <g>
        <g id="Layer_1">
          <path
            d="M94.2 0c12.2.2 24 2.7 35.2 6.5 10.9 3.8 21.2 9.1 30.7 15.6 9.1 6.5 17.8 14.5 25.2 23.4 7.3 8.9 13.8 19.1 18.5 30.5 4.9 11.6 7.8 23.4 8.5 35 0 1.1.2 2 .2 3.1-.6 29.9-5.4 49.1-22.4 64.7-22.7 20.9-40.8 27.9-74.5 27.9-27.1 0-53.2-14.6-66.4-24.4-10.9-8.1-26.9-22.4-35.6-40.1C.4 115.6-.4 99.5.1 81.8c.5-17.4 9.7-36.7 22.6-51.4 10.5-12 24-20.4 35.5-24.6C69.3 1.7 81.3-.3 94.2 0zm65.4 24c-8.9-6-18.7-11.1-28.9-14.7-10.5-3.6-21.8-5.6-33.4-5.6-11.8-.2-23.2 1.8-33.4 5.6-10.9 4-20.7 10.2-28.7 18.3-8.7 8.5-15.4 18.9-19.6 30.9-4.5 12.7-6.2 26.9-4 42.3 2.2 16 8.2 31.2 17.4 44.5 9.4 13.8 21.4 25.4 35.4 34.3 13.8 8.7 28.9 14.5 44.5 16.7 15.1 2.2 30.3.9 44.5-4 13.4-4.5 24.5-12 33.2-21.2 8.2-8.7 14-18.9 17.8-30.1 3.3-10.5 4.9-21.6 4.2-33-.7-10.9-3.1-22-7.8-33.2-4.5-10.7-10.2-20.3-17.4-28.9-6.9-8.1-14.9-15.6-23.8-21.9z"
            className="st0"
          />
          <path
            d="M98.2 8.2c2.4 0 4.7 0 6.9.2 1.8 5.3 3.3 10.7 5.1 16.3-2.4-.2-4.7-.2-7.1-.2s-4.7.2-7.1.7c-1.6-5.6-3.1-11.1-4.7-16.5 2.3-.3 4.7-.5 6.9-.5zm25 3.4c14.9 4.2 28.9 11.8 40.5 22 11.8 10.5 21.4 23.2 27.6 38.7 6.2 15.6 8 32.1 5.3 47-2.9 16-10.9 30.7-23.8 41.6-2.7-8.5-5.3-16.5-8-24.7 4.9-4.7 8.7-10.5 11.4-16.9 3.6-8.7 4.9-18.3 3.8-28.3-5.6.9-11.4 2-17.4 2.9-.2 4.9-1.3 9.6-3.3 14-4.7 9.6-13.4 17.1-25.4 19.8-12.5 2.7-25.8-.4-37-7.8-11.4-7.3-20-18.7-22.9-32.1-3.1-12.7-.2-24.5 6.5-33 6.2-8 16-13.1 27.8-14 11.1-.7 22.3 2.9 31.4 9.4 4.2 2.9 8 6.2 11.4 10.2 5.8-.7 11.4-1.1 16.9-1.8-5.6-8.2-12.7-15.4-20.7-20.7-5.8-4-11.8-7.1-18.3-9.4-2-5.6-4.1-11.4-5.8-16.9zm32.2 160.3c-2.7 1.1-5.1 2-7.8 2.9-2.7.9-5.6 1.6-8.2 2.2-2.4-8.7-4.7-17.1-7.1-25.4 2.9-.2 5.6-.7 8.2-1.6 2.7-.7 5.1-1.6 7.6-2.4 2.5 7.8 4.7 16 7.3 24.3zm-39.4 6.4c-21.6-1.8-42.5-11.1-59.4-26.3-16.7-15.1-28.5-35.6-31.8-57.2-3.6-21.4 1.1-39.6 10.7-54.3C44.4 27.1 57.8 17.1 73.3 12c1.8 6.2 3.3 12.2 4.9 18.7-6 3.1-11.4 7.1-15.8 12.2-10.5 12-15.6 29.2-11.8 48.3 4 20 16.9 37.6 34.1 48.8 7.6 4.9 15.8 8.5 24.5 10.5 2.2 8.9 4.4 18.2 6.8 27.8z"
            className="st0"
          />
        </g>
      </g>
    </switch>
  </svg>
);

export default Cloudcoin;
